import { z } from 'zod';

export const IntegrationRunStatusSchema = z.enum([
  'running',
  'waiting_approval',
  'completed',
  'error',
  'cancelled',
]);
export type IntegrationRunStatus = z.infer<typeof IntegrationRunStatusSchema>;
